import axios from "axios";

const SERVER_URL = process.env.REACT_APP_BASE_API;
const MAPS_API = process.env.REACT_APP_MAPS_API;
const EMAIL = process.env.REACT_APP_EMAIL;
const PASS = process.env.REACT_APP_PASS

const axiosBaseInstance = axios.create({
    baseURL: SERVER_URL,
})

const topo_colors = [
   "#FF0000", // Bright Red
  "#00FF00", // Bright Green
  "#0000FF", // Bright Blue
  "#FF00FF", // Magenta / Pink
  "#FF1493", // Deep Pink
  "#7FFF00", // Chartreuse
  "#FF4500", // Orange Red
  "#af2aaaff",
  "#1512cdff", 
  "#F46036", // Vivid Orange
  "#6A4C93", // Royal Purple
  "#085F63", // Deep Cyan
  "#0B6623", // Dark Green
  "#A23B72", // Dark Magenta
  "#E55934", // Strong Burnt Orange
  "#00509E", // Dark Blue
  "#7C4700"  // Strong Brown
]

const mineData = [
    {
        id: "1",
        name: "SULIYARI COAL MINES",
        location: {
            lat: 23.93371751223374,
            lng: 82.33035954134644,
        },
        root: SERVER_URL+'/static/data/SULIYARI',
        orthoPaths: ["9th_ortho", "10th_ortho"],
        DSMPaths: ["output_9th_dsm", "output_10th_dsm"],
        DTMPaths: ["output_9th_dtm", "output_10th_dtm"],
        geoPaths: ["output1.geojson", "output2.geojson"],
        modelPath: 'talabira_potree',
        elevationPath: ['elevation1/leaflet-elevation_toggable-tracks_main_final.htm', 'elevation2/leaflet-elevation_toggable-tracks_main_final.htm'],
        mapBounds: {
            lat1: 23.923104881414023,
            lat2: 23.946892155311765,
            lng1: 82.31238760208954,
            lng2: 82.34542889305189
        },
        status: ['success', 'Normal'],
        visits: ['9th Visit', '10th Visit'],
        inspectionDate: "20th Sep 2023",
        inspectionArea: "5000 sq km"
    },
    {
        id: "2",
        name: "GP-III_BAJARMUDA",
        location: {
            lat: 22.17416448102037,
            lng: 83.4871498117263,
        },
        root: SERVER_URL+"/static/data/GP3",
        orthoPaths: ["9th_ortho", "10th_ortho"],
        DSMPaths: ["dsm", ""],
        DTMPaths: ["output_gp3_dtm", "output_cgeck"],
        geoPaths: ["output1.geojson", "output2.geojson"],
        modelPath: 'landsite2',
        elevationPath: null,
        mapBounds: {
            lat1: 22.17416448102037,
            lat2: 22.18858439575992,
            lng1: 83.4871498117263,
            lng2: 83.51723190023472
        },
        status: ['warning', 'Minor'],
        visits: ['5th Visit'],
        inspectionDate: "20th Sep 2023",
        inspectionArea: "5000 sq km"
    },
    {
        id: "3",
        name: "TALABIRA",
        location: {
            lat: 21.7420165602,
            lng: 83.9526246420,
        },
        root: SERVER_URL+"/static/data/TALABIRA",
        orthoPaths: ["visit1/ortho", "visit2/ortho"],
        DSMPaths: ["visit1/dsm", "visit2/dsm"],
        DTMPaths: ["visit1/dtm", "visit2/dtm"],
        slopePaths: ["visit1/slopemap", "visit2/slopemap"],
        // hillshadePaths: ["visit1/hillshade", "visit2/hillshade"],
        haulPaths: ["visit1/haulroad", "visit2/haulroad"],
        tifPaths: ["visit1", "visit2"],
        geoPaths: [
            {
                paths: [
                    "contours/visit1/TALABIRA_21TH_VISIT_CONTOUR_5_M_INTERVAL.geojson",
                    // "contours/visit1/1752240235_497.geojson"
                ]
            },
            {
                paths: [
                    "contours/visit2/TALABIRA_22ND_VISIT_CONTOUR_5_M_INTERVAL.geojson"
                ]
            },
        ],
        topoPaths: [
            {
                paths: []
            },
            {
                paths: ['topos/visit1/Feature_Label', 'topos/visit1/Shed', 'topos/visit1/Boundary_Wall', 'topos/visit1/GCP_Details', 'topos/visit1/Well', 'topos/visit1/Fence', 'topos/visit1/Waterlogged_Area', 'topos/visit1/Electric_Line', 'topos/visit1/HT_Line', 'topos/visit1/Haul_Road', 'topos/visit1/Asphal_Road', 'topos/visit1/Quarry', 'topos/visit1/Culvert', 'topos/visit1/Building', 'topos/visit1/Dump', 'topos/visit1/GCP', 'topos/visit1/Wateertank', 'topos/visit1/Weigh_Bridge', 'topos/visit1/Drain', 'topos/visit1/Foot_Track', 'topos/visit1/Mud_Road', 'topos/visit1/Stock']
            },
            // {
            //     paths: ['topos/visit2/Feature_Label', 'topos/visit2/Shed', 'topos/visit2/Boundary_Wall', 'topos/visit2/GCP_Details', 'topos/visit2/Well', 'topos/visit2/Fence', 'topos/visit2/Waterlogged_Area', 'topos/visit2/Electric_Line', 'topos/visit2/HT_Line', 'topos/visit2/Haul_Road', 'topos/visit2/Asphal_Road', 'topos/visit2/Quarry', 'topos/visit2/Culvert', 'topos/visit2/Building', 'topos/visit2/Dump', 'topos/visit2/GCP', 'topos/visit2/Wateertank', 'topos/visit2/Weigh_Bridge', 'topos/visit2/Drain', 'topos/visit2/Foot_Track', 'topos/visit2/Mud_Road', 'topos/visit2/Stock']
            // },
        ],
        modelPath: ['pointclouds/visit1/STOCK', 'pointclouds/visit2/STOCK'],
        elevationPath: ["elevation1/leaflet-elevation_toggable-tracks_main_final.htm"],
        volumeSegments: [
            {
                ogls: ["volumeSegments/visit2/ogl/OGL.tif"],
                stockraw: ["volumeSegments/visit2/stock/STOCK.tif"],
                stocks: ["volumeSegments/visit2/tiles/segment1"]
            },
            {
                ogls: ["volumeSegments/visit1/ogl/OGL.tif"],
                stockraw: ["volumeSegments/visit1/stock/STOCK.tif"],
                stocks: ["volumeSegments/visit1/tiles/segment1"]
            },
        ],
        hillshadePaths:[
            {
                hillshade:"visit1/hillshade",
                color:"visit1/color",
                grad:"visit1/grad"
            },
            {
                hillshade:"visit2/hillshade",
                color:"visit2/color"
            }
        ],
        // mapBounds: {
        //     lat1: 22.173834835158548,
        //     lat2: 22.187800486684516,
        //     lng1: 83.48419024906505,
        //     lng2: 83.50564750385067
        // },
        mapBounds: {
            lat1: 21.7420165602,
            lat2: 21.7703437069,
            lng1: 83.9526246420,
            lng2: 83.9886895997
        },
        status: ['warning', 'Minor'],
        visits: ['2nd March', '1st April'],
        inspectionDate: "",
        inspectionArea: ""
    },

    {
        id: "4",
        name: "MEGHALYA",
        location: {
            lat: 25.165653833973778,
            lng: 92.37918820748072,
        },
        root: SERVER_URL+"/static/data/MEGHALYA",
        orthoPaths: ["visit1/ortho", "visit2/ortho"],
        DSMPaths: ["visit1/dsm", "visit2/dsm"],
        DTMPaths: ["visit1/dtm", "visit2/dtm"],
        slopePaths: ["visit1/slopemap", "visit2/slopemap"],
        // hillshadePaths: ["visit1/hillshade", "visit2/hillshade"],
        haulPaths: ["visit1/haulroad", "visit2/haulroad"],
        tifPaths: ["visit1", "visit2"],
        geoPaths: [
            {
                paths: [
                    "contours/visit1/TALABIRA_21TH_VISIT_CONTOUR_5_M_INTERVAL.geojson",
                    // "contours/visit1/1752240235_497.geojson"
                ]
            },
            {
                paths: [
                    "contours/visit2/TALABIRA_22ND_VISIT_CONTOUR_5_M_INTERVAL.geojson"
                ]
            },
        ],
        topoPaths: [
            {
                paths: ['topos/visit1/BOUNDARY_WALL', 'topos/visit1/WEIGH_BRIDGE', 'topos/visit1/ROAD', 'topos/visit1/FENCE', 'topos/visit1/STREAM', 'topos/visit1/SHED', 'topos/visit1/STOCK_YARD', 'topos/visit1/WASTE', 'topos/visit1/DRAIN', 'topos/visit1/QUARRY', 'topos/visit1/BUILDING', 'topos/visit1/LIGHT_POLE', 'topos/visit1/WATER_BODY', 'topos/visit1/ELECTRIC_POLE', 'topos/visit1/DUMPYARD', 'topos/visit1/ELECTRIC_LINE']
            },
            {
                paths: []
            },
            // {
            //     paths: ['topos/visit2/Feature_Label', 'topos/visit2/Shed', 'topos/visit2/Boundary_Wall', 'topos/visit2/GCP_Details', 'topos/visit2/Well', 'topos/visit2/Fence', 'topos/visit2/Waterlogged_Area', 'topos/visit2/Electric_Line', 'topos/visit2/HT_Line', 'topos/visit2/Haul_Road', 'topos/visit2/Asphal_Road', 'topos/visit2/Quarry', 'topos/visit2/Culvert', 'topos/visit2/Building', 'topos/visit2/Dump', 'topos/visit2/GCP', 'topos/visit2/Wateertank', 'topos/visit2/Weigh_Bridge', 'topos/visit2/Drain', 'topos/visit2/Foot_Track', 'topos/visit2/Mud_Road', 'topos/visit2/Stock']
            // },
        ],
        modelPath: ['pointclouds/visit1/STOCK', 'pointclouds/visit2/STOCK'],
        elevationPath: ["elevation1/leaflet-elevation_toggable-tracks_main_final.htm"],
        volumeSegments: [
            {
                ogls: ["volumeSegments/visit2/ogl/OGL.tif"],
                stockraw: ["volumeSegments/visit2/stock/STOCK.tif"],
                stocks: ["volumeSegments/visit2/tiles/segment1"]
            },
            {
                ogls: ["volumeSegments/visit1/ogl/OGL.tif"],
                stockraw: ["volumeSegments/visit1/stock/STOCK.tif"],
                stocks: ["volumeSegments/visit1/tiles/segment1"]
            },
        ],
        hillshadePaths:[
            {
                hillshade:"visit1/hillshade",
                color:"visit1/color",
                grad:"visit1/grad"
            },
            {
                hillshade:"visit2/hillshade",
                color:"visit2/color"
            }
        ],

        mapBounds: {
            lat1:25.162135738383892,
            lat2: 25.16917192956366,
            lng1: 92.37683253703547,
            lng2: 92.38154387792596
        },
        status: ['warning', 'Minor'],
        visits: ['Visit 1', 'Visit 2'],
        inspectionDate: "",
        inspectionArea: ""
    },

    {
        id: "5",
        name: "ADANI_DAHEGAON",
        location: {
            lat: 21.273204306,
            lng: 78.963084306,
        },
        root: "BAJARMUDA",
        orthoPaths: ["GP3fifth_tiles", "tiles"],
        DSMPaths: ["output_gp3_dsm", "output_cgeck"],
        DTMPaths: ["output_gp3_dtm", "output_cgeck"],
        geoPaths: ["output1.geojson", "output2.geojson"],
        modelPath: 'landsite2',
        elevationPath: null,
        mapBounds: {
            lat1: 21.2499030556,
            lat2: 21.2965055556,
            lng1: 78.9345013889,
            lng2: 78.9916672222,
        },
        status: ['warning', 'Minor'],
        visits: ['5th Visit'],
        inspectionDate: "20th Sep 2023",
        inspectionArea: "5000 sq km"
    },
    {
        id: "6",
        name: "MADHERI",
        location: {
            lat: 20.372803194,
            lng: 78.775341389,
        },
        root: "BAJARMUDA",
        orthoPaths: ["GP3fifth_tiles", "tiles"],
        DSMPaths: ["output_gp3_dsm", "output_cgeck"],
        DTMPaths: ["output_gp3_dtm", "output_cgeck"],
        geoPaths: ["output1.geojson", "output2.geojson"],
        modelPath: 'landsite2',
        elevationPath: null,
        mapBounds: {
            lat1: 20.3452330556,
            lat2: 20.4003733333,
            lng1: 78.7252480556,
            lng2: 78.8254347222,
        },
        status: ['warning', 'Minor'],
        visits: ['5th Visit'],
        inspectionDate: "20th Sep 2023",
        inspectionArea: "5000 sq km"
    },
]

const mineDataById = mineData.map((el) => {
    let temp = {}
    temp[el.id] = el
    return temp
})

const userCreds = {email:EMAIL, password:PASS}

export { mineDataById, mineData, SERVER_URL, MAPS_API, axiosBaseInstance, topo_colors, userCreds }